'use memo';

import { CampaignDetailModel, useGetCampaign } from '@urbanx/agx.campaigns.client';
import { useAppSelector } from './useAppSelector';

export const useNewSelectedCampaign = (): {
  selectedCampaign: CampaignDetailModel | undefined;
  isSelectedCampaignPending: boolean;
} => {
  const { selectedCampaignId } = useAppSelector((state) => state.campaigns);

  const { data: selectedCampaign, isPending: isSelectedCampaignPending } = useGetCampaign(
    selectedCampaignId ?? '',
    !!selectedCampaignId
  );

  return { selectedCampaign, isSelectedCampaignPending };
};
